import { LoadingOverlay, LoadingOverlayProps } from '@mantine/core'
import { memo } from 'react'

export interface BaseLoadingOverlayProps extends LoadingOverlayProps {
  visible: boolean
}

/**
 * 跟 mantine 的 LoadingOverlay 差不多
 * @returns
 */
const BaseLoadingOverlay = ({ visible, ...props }: BaseLoadingOverlayProps) => {
  return <LoadingOverlay loader={<LoadingSquareAnimate />} zIndex={10} visible={visible} {...props} />
}

export const LoadingSquareAnimate = ({ fill = '#2354E6' }) => (
  <svg x="0px" y="0px" width="36px" height="8px" viewBox="0 0 36 8">
    <rect x="0" y="0" width="8" height="8" fill={fill}>
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="1; .3; 1"
        begin="0s"
        dur="0.8s"
        repeatCount="indefinite"
      />
    </rect>
    <rect x="14" y="0" width="8" height="8" fill={fill}>
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="1; .3; 1"
        begin="0.27s"
        dur="0.8s"
        repeatCount="indefinite"
      />
    </rect>
    <rect x="28" y="0" width="8" height="8" fill={fill}>
      <animate
        attributeName="opacity"
        attributeType="XML"
        values="1; .3; 1"
        begin="0.54s"
        dur="0.8s"
        repeatCount="indefinite"
      />
    </rect>
  </svg>
)

export default memo(BaseLoadingOverlay)
